import React, { Fragment, useEffect } from "react";
import { seo } from "../../utils/utils";
import strings from "translate/language";


const Support = () => {
  // const dispatch = useDispatch();
  // const [privacyData, setPrivacyData] = useState({});

  // const PrivacyPolicySelector = useSelector(
  //   (state) => state.configurationSettingDetail
  // );

  // useEffect(() => {
  //   if (PrivacyPolicySelector?.result) {
  //     setPrivacyData(handleDetailResponse(PrivacyPolicySelector?.result?.data));
  //   }
  // }, []);

  // useEffect(() => {
  //   dispatch(getPrivacyPolicy());
  // }, [dispatch]);

  useEffect(() => {
    seo({
      title: "Support",
      metaDescription: "Support",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <Fragment>
      <div className="page-body">

        <div className="container-fluid m-3">
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-4d81c6f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="4d81c6f"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-default">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c1c75e2"
                data-id="c1c75e2"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-630dc7d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="630dc7d"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-default">
                      <div
                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ddea7ef"
                        data-id="ddea7ef"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="pp_section elementor-element elementor-element-b0e1859 elementor-widget elementor-widget-tm-custom-title"
                            data-id="b0e1859"
                            data-element_type="widget"
                            data-widget_type="tm-custom-title.default"
                          >
                            <div className="elementor-widget-container mb-5">
                              <div className="page-builder-custom-title-wrap">
                                <h1 className="title">{strings.constactUs}</h1>
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5b355fc"
                        data-id="5b355fc"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="pp_section elementor-element elementor-element-3e8e85a elementor-widget elementor-widget-tm-contact-icons"
                            data-id="3e8e85a"
                            data-element_type="widget"
                            data-widget_type="tm-contact-icons.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="contacts__info contact-info">
                                <li className="contact-info__item">
                                  <div className="contact-info__icon">
                                    <i className="fa fa-map-marker" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                                  </div>
                                  <div className="contact-info__content">
                                    <div className="contact-info__title">{strings.headOffice}</div>
                                    <div className="contact-info__text">
                                      <address>
                                        Justo Infotech Labs Private limited, 1306 Fiorello, Nahar Amrit Shakti R-2, Chandivali, Mumbai City, Maharashtra, India 400072.
                                      </address>{" "}
                                    </div>
                                  </div>
                                </li>
                                <li className="contact-info__item">
                                  <div className="contact-info__icon">
                                    <i className="fa fa-envelope" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                                  </div>
                                  <div className="contact-info__content">
                                    <div className="contact-info__title">{strings.email}</div>
                                    <div className="contact-info__text">
                                      <a href="mailto:support@justo.co.in">
                                        support@justo.co.in
                                      </a>{" "}
                                    </div>
                                  </div>
                                </li>
                                <li className="contact-info__item">
                                  <div className="contact-info__icon">
                                    <i className="fa fa-phone" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                                  </div>
                                  <div className="contact-info__content">
                                    <div className="contact-info__title">{strings.phone}</div>
                                    <div className="contact-info__text">
                                      <a href="tel:+919922001907">(+91) 9922001907 </a>{" "}
                                    </div>
                                  </div>
                                </li>
                                <li className="contact-info__item">
                                  <div className="contact-info__icon">
                                    <i className="fa fa-globe" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                                  </div>
                                  <div className="contact-info__content">
                                    <div className="contact-info__title">{strings.website}</div>
                                    <div className="contact-info__text">
                                      <a href="https://justo.co.in/">www.justo.co.in</a>{" "}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </Fragment>
  );
};

export default Support;
